module.exports = __webpack_public_path__ + "img/login-diegoocania.1b5122fd.svg";